module.exports = __webpack_public_path__ + "static/media/icon_150.5f8af65a.svg";